import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import "./compromiso.scss"

export const CompromisoSection = () => {
  return (
    <>
      <section className="compromiso-section" id="Compromiso">
        <StaticImage
          src="../../../images/poligonos/circulo-azul.svg"
          alt="circulo-azul"
          className="circulo-azul"
          placeholder="tracedSVG"
        />
        <StaticImage
          src="../../../images/home/compromiso/Compromiso-conocimiento-dedicacion.jpg"
          alt={`compromiso-landing-image`}
          className={`compromiso-img animate__animated animate__fadeInUp animate__delay-2s`}
        />
        <div className="compromiso-section-texto animate__animated animate__fadeInUp animate__delay-2s">
          <div
            className="compromiso-title-container"
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
          >
            <h2 className="mb-0 title-blue">Compromiso,</h2>
            <h2 className="mb-0 title-orange">conocimiento</h2>
            <h2 className="mb-0 title-blue">y dedicación.</h2>
          </div>
          <div
            className="compromiso-text-container"
            data-sal="slide-up"
            data-sal-delay="400"
            data-sal-easing="ease"
          >
            <p>
              Para asegurar el éxito en cada desafío nos comprometemos a
              escuchar y diseñar, integrar y ejecutar, y brindar soporte
              especializado de la mano de nuestro excelente grupo de
              profesionales.
            </p>
          </div>
          <div
            className="compromiso-logos-container"
            data-sal="slide-up"
            data-sal-delay="500"
            data-sal-easing="ease"
          >
            <div className="compromiso-item compromiso-item-escuchar-container">
              <StaticImage
                src="../../../images/home/compromiso/Escuchar-y-diseñar-Icono.svg"
                alt={`logo-escuchar`}
                className={`logo-escuchar`}
                placeholder="tracedSVG"
              />
              <p>Escuchar y diseñar</p>
            </div>
            <div className="compromiso-item compromiso-item-integrar-container">
              <StaticImage
                src="../../../images/home/compromiso/Integrar-y-ejecutar-icono.svg"
                alt={`logo-integrar`}
                className={`logo-integrar`}
                placeholder="tracedSVG"
              />
              <p>
                Integrar <br /> y ejecutar
              </p>
            </div>
            <div className="compromiso-item compromiso-item-brindar-container">
              <StaticImage
                src="../../../images/home/compromiso/Brindar-soporte-Icono.svg"
                alt={`logo-brindar`}
                className={`logo-brindar`}
                placeholder="tracedSVG"
              />
              <p>Brindar soporte</p>
            </div>
            <div className="compromiso-item-satisfaccion-container">
              <StaticImage
                src="../../../images/home/compromiso/Satisfacción-compelto.svg"
                alt={`logo-satisfaccion`}
                className={`logo-satisfaccion`}
                placeholder="tracedSVG"
              />
            </div>
          </div>
        </div>
        <StaticImage
          src="../../../images/poligonos/triangulo-naranja.svg"
          alt="triangulo-naranja"
          className="triangulo-naranja"
          placeholder="tracedSVG"
        />
      </section>
    </>
  )
}
